<template>
    <div class="table-responsive">
        <loading :show="show" :label="label" :overlay="overlay"></loading>
        <div class="barra_botoes_exportar">
            <span class="titulo_btnexport">Exportar para: </span>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            :name="nomearquivo+'.xls'">
                <img alt="Exportar para xls" title=".xls" src="../../../assets/images/icon_xls.png">
            </download-excel>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            type="csv"
            :name="nomearquivo+'.csv'">
                <img alt="Exportar para csv" title=".csv" src="../../../assets/images/icon_csv.png">
            </download-excel>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            :name="nomearquivo+'.doc'">
                <img alt="Exportar para dpc" title=".doc" src="../../../assets/images/icon_doc.png">
            </download-excel>
            <div class="btn_exportnew"><a v-on:click="exportarpdf()">
                <img alt="Exportar para pdf" title=".pdf" src="../../../assets/images/icon_pdf.png">
            </a></div>
        </div>
        <table class="table table-striped">
            <thead class="">
                <tr>
                    <th style="vertical-align: center !important;">Processo</th>
                    <th style="text-align:center !important;">Número Licitação</th>
                    <th style="text-align:center !important;">Fonecedor</th>
                    <th style="text-align:center !important;">Data Assinatura</th>
                    <th style="text-align:center !important;">Data Validade</th>
                    <th>Objeto</th>
                    <th style="text-align:center !important;">Valor do Contrato</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="itens in dadosconteudo.tr">
                    <td v-if="itens.processo != ''" :rowspan="itens.rowspan" style="vertical-align: top !important;">{{itens.processo}}</td>
                    <td style="text-align:center !important; vertical-align: top !important;">{{{itens.numerolicitacao}}}</td>
                    <td style="text-align:center !important; vertical-align: top !important; min-width: 140px">
                        {{itens.cpfcnpj}}<br />
                        {{itens.nomefornecedor}}
                    </td>
                    <td style="text-align:center !important; vertical-align: top !important;">{{{itens.dataassinatura}}}</td>
                    <td style="text-align:center !important; vertical-align: top !important;">{{{itens.datavalidade}}}</td>
                    <td style="text-align:left !important; vertical-align: top !important;">
                        <span style="cursor:pointer;color: #5b9bd1;" @click="loadmodalinfomodal(itens.infomodal)">
                            {{itens.objeto}}
                        </span>
                        <info-modal :line="itens.infomodal"></info-modal>
                    </td>
                    <td style="text-align:center !important; vertical-align: top !important;width: 120px;">
                        {{itens.valorcontrato}}
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="text-center">
            <cp-paginate :source="dadosconteudo" @navigate="navigate"><cp-paginate>
        </div>
    </div>
    <!-- Modal de informações -->
    <!-- <div v-for="modinfo in dadosconteudo.tr">
        <info-modal :line="modinfo.infomodal"></info-modal>
    </div> -->
    <!-- fim Modal de informações -->
    <!-- Modal de informações -->
        <!-- <div v-for="userfase in dadosconteudo.tr">
            <modal-user v-if="userfase.telamodal == true" :line="userfase"></modal-user>
        </div> -->
    <!-- </div> -->
    <!-- fim Modal de informações -->
</template>
<script>
import InfoModal from "./modal/infomodal.vue";
import CpPaginate from "../../pagination/pagination.vue";
import downloadExcel from "vue-json-excel";
import ModalUser from "./modaluser/usermodal.vue";

export default {
  data() {
    return {
      dadostitulo: {
        Processo: "processo",
        "Número Licitação": "numerolicitacao",
        Fonecedor: "nomefornecedor2",
        "Data Assinatura": "dataassinatura",
        "Data Validade": "datavalidade",
        Objeto: "objeto",
        "Valor do Contrato": "valorcontrato",
      },
      dadosexportar: {},
      nomearquivo: "",
      tituloexport: "",
      json_meta: [[{ key: "charset", value: "utf-8" }]],
      show: false,
      label: "Gerando arquivo...",
      overlay: true,
      dadostable: {},
      telamodal: true,
    };
  },
  components: { InfoModal, CpPaginate, ModalUser, downloadExcel },
  ready() {
    // $.getScript("./src/assets/js/puremask.min.js");
    $(".table-responsive").fadeOut("fast");
  },
  watch: {
    $route() {
      $(".table-responsive").fadeOut("fast");
    },
  },
  props: ["dadosconteudo"],
  methods: {
    loadmodalinfomodal(item) {
      setTimeout(function () {
        $("#" + item).modal("show");
      }, 300);
    },
    fetchData() {
      $.ajaxSetup({
        async: false,
      });

      var self = this;
      var page = "-1";
      MPL.loadDadosContratos(page, function (dados) {
        self.dadosexportar = dados[0].tr;
      });

      $.ajaxSetup({
        async: true,
      });

      this.tituloexport = window.dadosconteudogeral.titulopagina;
      var tit = this.tituloexport[0];
      tit = tit.split(/\s*\\s*/);
      tit = tit[0].replace(/\s/g, "");
      this.nomearquivo = tit;
      return self.dadosexportar;
    },
    exportarpdf() {
      this.show = true;
      // $.ajaxSetup({
      //     async: false
      // });

      var exportpdf;
      var self = this;
      var page = "-1";
      MPL.loadDadosContratos(page, function (dados) {
        exportpdf = dados[0].tr;

        var colunas = [
          { title: "Processo", dataKey: "processo" },
          { title: "Número Licitação", dataKey: "numerolicitacao" },
          { title: "Fonecedor", dataKey: "nomefornecedor2" },
          { title: "Data Assinatura", dataKey: "dataassinatura" },
          { title: "Data Validade", dataKey: "datavalidade" },
          { title: "Objeto", dataKey: "objeto" },
          { title: "Valor do Contrato", dataKey: "valorcontrato" },
        ];

        var doc = new jsPDF("l", "pt");

        var titulopdf = window.dadosconteudogeral.titulopagina;
        var tit = titulopdf[0];
        tit = tit.split(/\s*\\s*/);
        tit = tit[0].replace(/\s/g, "");
        self.nomearquivo = tit;

        doc.autoTable(colunas, exportpdf, {
          styles: { overflow: "linebreak" },
          columnStyles: {
            processo: { columnWidth: 100, valign: "top" },
            numerolicitacao: { columnWidth: 70, valign: "top" },
            nomefornecedor2: { columnWidth: 120, valign: "top" },
            dataassinatura: { columnWidth: 93, valign: "top" },
            datavalidade: { columnWidth: 80, valign: "top" },
            objeto: { valign: "top" },
            valorcontrato: { columnWidth: 100, valign: "top" },
          },
          addPageContent: function (data) {
            doc.text(titulopdf, 40, 30);
          },
        });

        doc.save(self.nomearquivo + ".pdf");
        self.show = false;
      });

      // $.ajaxSetup({
      //     async: true
      // });
      //console.dir(exportpdf)
    },
    navigate(page) {
      $.ajaxSetup({
        async: false,
      });

      var self = this;

      MPL.loadDadosContratos(page, function (dados) {
        //self.dadosconteudo = dados[0];
        self.dadosconteudo = dados[0];
        self.dadostable = dados[0];
        //alert(self.$route.params.tipo)
        //console.log(dados[0].conteudo)
      });

      $.ajaxSetup({
        async: true,
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// table.vue?8e7729d6